import { render, staticRenderFns } from "./SelectedTransactionCard.vue?vue&type=template&id=6f4d9efc&"
import script from "./SelectedTransactionCard.vue?vue&type=script&lang=js&"
export * from "./SelectedTransactionCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VCol,VExpandTransition})
